import React from "react";
import Banner from "../components/about/Banner";
import CommonContainer from "../components/shared/CommonContainer";
import { Flex, Image, Stack, Text } from "@chakra-ui/react";
import WhySection from "../components/about/WhySection";

export default function AboutPage() {
  return (
    <CommonContainer>
      <Banner />
      <Flex
        gap={{ base: 10 }}
        flexDir={{ base: "column-reverse", xl: "row" }}
        py={10}
      >
        <Stack
          w={{ xl: "40%" }}
          gap={5}
          fontSize={{ base: "12px",md: "17px", xl: "21px" }}
        >
          <Text color="#FF0000">
            All transactions conducted on our platform use cryptocurrency as a
            means of settlement, which serves to facilitate a connection between
            buyers and sellers that is built on a foundation of trust. Each
            settlement is driven by a smart contract interaction without
            third-party interference, which serves to maintain integrity and
            transparency all the way through to successful project completion.
          </Text>
          <Text color="#848484">
            We strive to connect small businesses, entrepreneurs, and
            corporations with the best and brightest content creators, creative
            graphic artists, website designers, and much more. By combining
            exclusive use of cryptocurrency as a settlement method, along with a
            foolproof verification system that eliminates risk of fraud,
            Decolance provides a smooth, seamless, and stress-free process with
            exceptional results. Decolance provides freelancers with a secure
            platform to showcase their talents, and offers businesses a global
            marketplace to find the best freelancers at affordable rates. Above
            all, our goal is to promote a seamless exchange of digital services,
            where sellers and buyers are true partners in collaboration, bonded
            by authenticity and transparency.
          </Text>
        </Stack>
        <Stack w={{ xl: "60%" }}>
          <Image src="/images/about/section.png" />
        </Stack>
      </Flex>
      <Stack gap={4} alignItems="center" my={20}>
        <WhySection />
        <Flex
          borderRadius={60}
          py={2}
          pl={2}
          bgGradient="linear(to-b,#0079BC,#74C7F5)"
          gap={4}
          alignItems="center"
          pr={10}
          my={10}
        >
          <Image src="/images/trust-matters/24hr.png" maxW={{base:"100px",md:"100%"}} />
          <Text
            color="white"
            maxW="780px"
            fontSize={{ base:"10px",md: "18px", lg: "24px" }}
          >
            We're here to help with any issues you may have, with a friendly
            customer support team at your service 24/7.
          </Text>
        </Flex>
      </Stack>
    </CommonContainer>
  );
}
